export default `query getArticle($articleId: ID, $slug: String) {
  getArticles(
    input: {
      filter: { 
        article_id: $articleId 
        slug: $slug
      }
    }
  ) {
    total_count
    items {
      created_at
      id
      image
      image_alt
      slug
      title
      updated_at
      summary {
        html
      }
      body {
        html
      }
      category {
        id
        name
        slug
      }
    }
  }
}
`;
